import * as React from "react";

import { IPanelProps, Panel } from "core/decorators/Panel";
import PageInfoConfig from "./PageInfoConfig";
import PageInfoPanelLayout from "./PageInfoPanelLayout";

@Panel({id: "page-info", configClass: PageInfoConfig})
class PageInfoPanel extends React.PureComponent<IPanelProps<PageInfoConfig>> {

	public render() {
		return <PageInfoPanelLayout config={this.props.config} />;
	}
}



// WEBPACK FOOTER //
// ./src/panels/pageInfo/PageInfo.panel.tsx